import axios from 'axios';

export default {
    namespaced: true,
    state: {
        balance: null,
        transactions: [],
        withdrawals: [],
    },
    actions: {
        shop_balance_get({ commit }) {
            return axios.get('shop-balance').then(r => {
                commit("SET_BALANCE", r.data.data.balance); return r;
            });
        },
        shop_balance_transactions({ commit }, params) {
            return axios.get('shop-balance/transactions', { params }).then(r => {
                commit("SET_TRANSACTIONS", r.data.data.transactions); return r;
            });
        },
        shop_balance_withdraw(_, payload) {
            return axios.post('shop-balance/withdraw', payload);
        },
        shop_balance_my_withdrawals({ commit }, params) {
            return axios.get('shop-balance/withdrawals', { params }).then(r => {
                commit("SET_WITHDRAWALS", r.data.data.requests); return r;
            });
        },
        // Admin
        admin_withdrawals_list({ commit }, params) {
            return axios.get('admin/shop-withdrawals', { params }).then(r => {
                commit("SET_WITHDRAWALS", r.data.data.requests); return r;
            });
        },
        admin_withdrawal_approve(_, { id, payload }) {
            return axios.put('admin/shop-withdrawals/' + id + '/approve', payload || {});
        },
        admin_withdrawal_reject(_, { id, payload }) {
            return axios.put('admin/shop-withdrawals/' + id + '/reject', payload);
        },
    },
    mutations: {
        SET_BALANCE(state, b) { state.balance = b; },
        SET_TRANSACTIONS(state, t) { state.transactions = t; },
        SET_WITHDRAWALS(state, w) { state.withdrawals = w; },
    },
};
